import { type ConfiguratorModuleSpecsFragment } from '../../../../api/fragments/ConfiguratorModuleSpecs';
import ConfiguratorModuleConfiguration from './ConfiguratorModuleConfiguration';
import ConfiguratorModuleEmail from './ConfiguratorModuleEmail';
import FinanceProductAssignments from './FinanceProductAssignments';
import { HeaderTabs } from './type';
import VehicleAssignments from './VehicleAssignments';

type ConfiguratorModuleInnerPageProps = {
    activeTab: HeaderTabs;
    module: ConfiguratorModuleSpecsFragment;
};

const ConfiguratorModuleInnerPage = ({ activeTab, module }: ConfiguratorModuleInnerPageProps) => {
    switch (activeTab) {
        case HeaderTabs.MainDetails:
            return <ConfiguratorModuleConfiguration module={module} />;

        case HeaderTabs.Vehicles:
            return <VehicleAssignments module={module} />;

        case HeaderTabs.FinanceProducts:
            return <FinanceProductAssignments module={module} />;

        case HeaderTabs.Email:
            return <ConfiguratorModuleEmail module={module} />;

        default:
            return null;
    }
};

export default ConfiguratorModuleInnerPage;
